/* Define Tú Cuerpo — interacciones propias (prefijo dc-) */
(function () {
  'use strict';
  // cada sección incluye este archivo: ejecutarlo una sola vez
  if (window.__dcScripts) return;
  window.__dcScripts = true;

  function initReveal() {
    var els = document.querySelectorAll('.dc-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('dc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador() {
    document.querySelectorAll('[data-dc-comp]').forEach(function (comp) {
      var mover = function (clientX) {
        var r = comp.getBoundingClientRect();
        var p = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
        comp.style.setProperty('--dc-pos', p + '%');
      };
      var activo = false;
      comp.addEventListener('pointerdown', function (e) { activo = true; mover(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (activo) mover(e.clientX); });
      window.addEventListener('pointerup', function () { activo = false; });
      comp.addEventListener('keydown', function (e) {
        var actual = parseFloat(getComputedStyle(comp).getPropertyValue('--dc-pos')) || 50;
        if (e.key === 'ArrowLeft') comp.style.setProperty('--dc-pos', Math.max(0, actual - 5) + '%');
        if (e.key === 'ArrowRight') comp.style.setProperty('--dc-pos', Math.min(100, actual + 5) + '%');
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-dc-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-dc-principal]');
      var minis = Array.prototype.slice.call(gal.querySelectorAll('[data-dc-mini]'));
      if (!principal || !minis.length || gal.dataset.dcListo) return;
      gal.dataset.dcListo = '1';
      var idx = 0;
      var ir = function (i) {
        idx = (i + minis.length) % minis.length;
        var m = minis[idx];
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = m.getAttribute('data-src');
          principal.srcset = m.getAttribute('data-srcset') || '';
          principal.alt = m.getAttribute('data-alt') || '';
          principal.style.opacity = 1;
        }, 150);
        minis.forEach(function (x) { x.classList.remove('is-activa'); });
        m.classList.add('is-activa');
        // mover solo la tira de miniaturas (scrollIntoView desplazaba toda la página en iPhone)
        var tira = m.parentNode;
        tira.scrollTo({ left: m.offsetLeft - (tira.clientWidth - m.offsetWidth) / 2, behavior: 'smooth' });
      };
      // tocar la foto la abre completa en pantalla
      var visor = document.createElement('div');
      visor.className = 'dc-visor';
      visor.setAttribute('role', 'dialog');
      visor.setAttribute('aria-modal', 'true');
      visor.innerHTML = '<button type="button" class="dc-visor__cerrar" aria-label="Cerrar">×</button><img alt="">';
      document.body.appendChild(visor);
      var visorImg = visor.querySelector('img');
      var cerrarVisor = function () { visor.classList.remove('is-abierto'); document.documentElement.style.overflow = ''; };
      visor.addEventListener('click', cerrarVisor);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarVisor(); });
      principal.style.cursor = 'zoom-in';
      principal.addEventListener('click', function () {
        visorImg.src = principal.currentSrc || principal.src;
        visorImg.alt = principal.alt;
        visor.classList.add('is-abierto');
        document.documentElement.style.overflow = 'hidden';
      });
      minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
      var prev = gal.querySelector('[data-dc-prev]');
      var next = gal.querySelector('[data-dc-next]');
      if (prev) prev.addEventListener('click', function () { ir(idx - 1); });
      if (next) next.addEventListener('click', function () { ir(idx + 1); });
      // deslizar con el dedo
      var x0 = null;
      principal.parentNode.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.parentNode.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-dc-cantidad]').forEach(function (c) {
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-paso') === '+' ? 1 : -1;
          input.value = Math.max(1, Math.min(10, v));
        });
      });
    });
  }

  function initModales() {
    document.querySelectorAll('[data-dc-abrir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = document.getElementById(btn.getAttribute('data-dc-abrir'));
        if (!m) return;
        if (m.parentNode !== document.body) document.body.appendChild(m);
        m.classList.add('is-abierto');
        document.documentElement.style.overflow = 'hidden';
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-dc-cerrar]')) {
        var m = e.target.closest('.dc-modal');
        if (m) { m.classList.remove('is-abierto'); document.documentElement.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dc-modal.is-abierto').forEach(function (m) { m.classList.remove('is-abierto'); });
        document.documentElement.style.overflow = '';
      }
    });
  }

  function initEntrega() {
    document.querySelectorAll('[data-dc-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 4;
      var sumar = function (dias) {
        var d = new Date();
        while (dias > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) dias--;
        }
        return d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
      };
      var a = el.querySelector('[data-dc-desde]');
      var b = el.querySelector('[data-dc-hasta]');
      if (a) a.textContent = sumar(min);
      if (b) b.textContent = sumar(max);
    });
  }

  function initBarra() {
    var barra = document.querySelector('[data-dc-barra]');
    var ancla = document.querySelector('[data-dc-ancla-compra]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    if (barra.parentNode !== document.body) document.body.appendChild(barra);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('is-visible', pasado);
      });
    });
    io.observe(ancla);
  }

  // Botones "#comprar": abren directamente el formulario de pago contra reembolso (Releasit).
  // Desde otra página (p. ej. la portada) se llega a la ficha con #comprar y se abre solo.
  function formularioAbierto() {
    var f = document.querySelector('.rsi-form-header');
    return !!(f && f.offsetParent);
  }
  function abrirFormulario(intentos) {
    if (formularioAbierto()) return true;
    // hay varios botones de Releasit con el mismo id: usar el visible
    var bs = document.querySelectorAll('#rsi_buy_now_button'), b = null;
    for (var i = 0; i < bs.length; i++) { if (bs[i].offsetParent) { b = bs[i]; break; } }
    if (!b) b = bs[0];
    if (b) {
      b.click();
      // al cargar la página el botón existe antes de estar listo: comprobar y reintentar
      if (intentos > 0) setTimeout(function () { if (!formularioAbierto()) abrirFormulario(intentos - 1); }, 600);
      return true;
    }
    if (intentos > 0) setTimeout(function () { abrirFormulario(intentos - 1); }, 250);
    else {
      var ancla = document.querySelector('[data-dc-ancla-compra]');
      if (ancla) ancla.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }
  window.dcComprar = function () { abrirFormulario(15); };

  function initComprar() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="#comprar"]');
      if (!a) return;
      var destino = a.getAttribute('href').split('#')[0];
      if (destino && destino !== location.pathname) return; // otra página: navega y se abre al llegar
      e.preventDefault();
      // si Releasit aún está cargando, el primer clic se pierde: reintentar hasta que abra
      abrirFormulario(15);
    });
    if (location.hash === '#comprar' && document.querySelector('[data-dc-ancla-compra]')) {
      history.replaceState(null, '', location.pathname + location.search);
      abrirFormulario(32);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initComprar();
    initReveal();
    initComparador();
    initGaleria();
    initCantidad();
    initModales();
    initEntrega();
    initBarra();
  });
  document.addEventListener('shopify:section:load', function () {
    initReveal(); initComparador(); initGaleria(); initCantidad(); initModales(); initEntrega();
  });
})();
